import React from 'react';
import { Box, Alert } from '@spothero/ui';
import useMobileBreakPoint from 'hooks/use-mobile-breakpoint';
import { TOOLTIPS, useTooltips } from 'pages/search/hooks/use-tooltips';
import { SEARCH_WIDGET_TOOLTIP_DARK_STYLE_OVERRIDE } from 'pages/search/utils/style/style-overrides';
import { useAllInPricingMobile } from 'pages/search/hooks/use-all-in-pricing-mobile';
import { AllInPricingCallout } from 'common/all-in-pricing/AllInPricingCallout';
const ToolTipSwitch = () => {
    const { isVisible: isTooltipVehicleVisible, text: tooltipVehicleText, handleClose: handleTooltipVehicleClose, } = useTooltips(TOOLTIPS.search_vehicle_popover);
    const { isVisible: isTooltipLoyaltyVisible, text: tooltipLoyaltyText, handleClose: handleTooltipLoyaltyClose, } = useTooltips(TOOLTIPS.loyalty_program_popover);
    if (isTooltipLoyaltyVisible)
        return (<Alert description={tooltipLoyaltyText} onDismissClick={handleTooltipLoyaltyClose} showDismiss status="neutral" background={'secondary.default'} showIcon={false}/>);
    if (isTooltipVehicleVisible)
        return (<Alert description={tooltipVehicleText} onDismissClick={handleTooltipVehicleClose} showDismiss status="neutral" showIcon={false}/>);
    return null;
};
export const MobileFilterCallouts = ({ showMissingVehicleTooltip = false, }) => {
    const [isAllInPricingMobileCalloutReady, setIsAllInPricingMobileCalloutReady,] = React.useState(false);
    const { isVisible: isTooltipVehicleVisible } = useTooltips(TOOLTIPS.search_vehicle_popover);
    const { isVisible: isTooltipLoyaltyVisible } = useTooltips(TOOLTIPS.loyalty_program_popover);
    const isMobile = useMobileBreakPoint();
    const { showMobileCallout: showAllInPricingMobileCallout, } = useAllInPricingMobile();
    const isVisible = isMobile &&
        ((isTooltipVehicleVisible && showMissingVehicleTooltip) ||
            isTooltipLoyaltyVisible ||
            showAllInPricingMobileCallout ||
            false);
    // delay showing mobile callouts to prevent flicker on initial render
    const isMountedRef = React.useRef(true);
    React.useEffect(() => {
        isMountedRef.current = true;
        const timer = setTimeout(() => {
            if (isMountedRef.current) {
                setIsAllInPricingMobileCalloutReady(true);
            }
        }, 1500);
        return () => {
            isMountedRef.current = false;
            clearTimeout(timer);
        };
    }, []);
    if (!isVisible) {
        return null;
    }
    if ((isTooltipVehicleVisible && showMissingVehicleTooltip) ||
        isTooltipLoyaltyVisible) {
        return (<Box marginTop={2} marginBottom={4} 
        // MR 10/27 - I was asked not to put this style in fe-ui due to bigger design discussion
        sx={{
                '.chakra-alert': SEARCH_WIDGET_TOOLTIP_DARK_STYLE_OVERRIDE,
            }}>
                <ToolTipSwitch />
            </Box>);
    }
    if (showAllInPricingMobileCallout) {
        return isAllInPricingMobileCalloutReady ? (<AllInPricingCallout />) : null;
    }
    return null;
};
